module.exports = __webpack_public_path__ + "img/loading_ho.b92b6b8a.jpg";